export default "__VITE_ASSET__BGSLiOgj__"